import { Animals } from 'reactApp/sections/Nestle/PetsCard/PetsCard.types';

export const animals = [
    { label: 'Кошка', value: Animals.cat },
    { label: 'Собака', value: Animals.dog },
    { label: 'Другое', value: Animals.other },
];

const dogBreeds = [
    { label: 'Без породы (дворняжка)', value: 'Без породы (дворняжка)' },
    { label: 'Австралийская овчарка (Аусси)', value: 'Австралийская овчарка (Аусси)' },
    { label: 'Австралийский келпи', value: 'Австралийский келпи' },
    { label: 'Австралийский силки терьер', value: 'Австралийский силки терьер' },
    { label: 'Австралийский терьер', value: 'Австралийский терьер' },
    { label: 'Австралийский хилер (Голубой хилер)', value: 'Австралийский хилер (Голубой хилер)' },
    { label: 'Австрийский пинчер', value: 'Австрийский пинчер' },
    { label: 'Азавак (туарегская борзая)', value: 'Азавак (туарегская борзая)' },
    { label: 'Акита', value: 'Акита' },
    { label: 'Альпийская таксообразная гончая', value: 'Альпийская таксообразная гончая' },
    { label: 'Аляскинский кли-кай', value: 'Аляскинский кли-кай' },
    { label: 'Аляскинский маламут', value: 'Аляскинский маламут' },
    { label: 'Аляскинский хаски', value: 'Аляскинский хаски' },
    { label: 'Американская акита', value: 'Американская акита' },
    { label: 'Американский бандог', value: 'Американский бандог' },
    { label: 'Американский булли', value: 'Американский булли' },
    { label: 'Американский бульдог', value: 'Американский бульдог' },
    { label: 'Американский голый терьер', value: 'Американский голый терьер' },
    { label: 'Американский кокер-спаниель', value: 'Американский кокер-спаниель' },
    { label: 'Американский питбультерьер', value: 'Американский питбультерьер' },
    { label: 'Американский стаффордширский терьер', value: 'Американский стаффордширский терьер' },
    { label: 'Американский фоксхаунд', value: 'Американский фоксхаунд' },
    { label: 'Анатолийская овчарка', value: 'Анатолийская овчарка' },
    { label: 'Анатолийская овчарка (Кангал)', value: 'Анатолийская овчарка (Кангал)' },
    { label: 'Английская овчарка', value: 'Английская овчарка' },
    { label: 'Английский бульдог', value: 'Английский бульдог' },
    { label: 'Английский кокер-спаниель', value: 'Английский кокер-спаниель' },
    { label: 'Английский мастиф', value: 'Английский мастиф' },
    { label: 'Английский пойнтер', value: 'Английский пойнтер' },
    { label: 'Английский сеттер', value: 'Английский сеттер' },
    { label: 'Английский спрингер-спаниель', value: 'Английский спрингер-спаниель' },
    { label: 'Английский той-терьер', value: 'Английский той-терьер' },
    { label: 'Английский фоксхаунд', value: 'Английский фоксхаунд' },
    { label: 'Англо-французская малая гончая', value: 'Англо-французская малая гончая' },
    { label: 'Аппенцеллер зенненхунд', value: 'Аппенцеллер зенненхунд' },
    { label: 'Аргентинский дог', value: 'Аргентинский дог' },
    { label: 'Арденский бувье', value: 'Арденский бувье' },
    { label: 'Артезиано-нормандский бассет', value: 'Артезиано-нормандский бассет' },
    { label: 'Артуазская гончая', value: 'Артуазская гончая' },
    { label: 'Арьежская гончая', value: 'Арьежская гончая' },
    { label: 'Арьежский бракк', value: 'Арьежский бракк' },
    { label: 'Атласская овчарка (Аиди)', value: 'Атласская овчарка (Аиди)' },
    { label: 'Афганская борзая', value: 'Афганская борзая' },
    { label: 'Аффенпинчер', value: 'Аффенпинчер' },
    { label: 'Баварская горная гончая', value: 'Баварская горная гончая' },
    { label: 'Бандог', value: 'Бандог' },
    { label: 'Басенджи', value: 'Басенджи' },
    { label: 'Баскская овчарка', value: 'Баскская овчарка' },
    { label: 'Бассет-хаунд', value: 'Бассет-хаунд' },
    { label: 'Бедлингтон-терьер', value: 'Бедлингтон-терьер' },
    { label: 'Белая швейцарская овчарка', value: 'Белая швейцарская овчарка' },
    { label: 'Бельгийская овчарка', value: 'Бельгийская овчарка' },
    { label: 'Бельгийская овчарка малинуа', value: 'Бельгийская овчарка малинуа' },
    { label: 'Бельгийский гриффон', value: 'Бельгийский гриффон' },
    { label: 'Бергамская овчарка', value: 'Бергамская овчарка' },
    { label: 'Бернский зенненхунд', value: 'Бернский зенненхунд' },
    { label: 'Бивер', value: 'Бивер' },
    { label: 'Бигль', value: 'Бигль' },
    { label: 'Бигль-харьер', value: 'Бигль-харьер' },
    { label: 'Билли', value: 'Билли' },
    { label: 'Бишон фризе', value: 'Бишон фризе' },
    { label: 'Бладхаунд', value: 'Бладхаунд' },
    { label: 'Болгарская овчарка', value: 'Болгарская овчарка' },
    { label: 'Болоньез', value: 'Болоньез' },
    { label: 'Большая англо-французская бело-рыжая гончая', value: 'Большая англо-французская бело-рыжая гончая' },
    { label: 'Большая англо-французская бело-черная гончая', value: 'Большая англо-французская бело-черная гончая' },
    { label: 'Большая англо-французская трехцветная гончая', value: 'Большая англо-французская трехцветная гончая' },
    { label: 'Большая голубая гасконская гончая', value: 'Большая голубая гасконская гончая' },
    { label: 'Большой вандейский бассет-гриффон', value: 'Большой вандейский бассет-гриффон' },
    { label: 'Большой вандейский гриффон', value: 'Большой вандейский гриффон' },
    { label: 'Большой швейцарский зенненхунд', value: 'Большой швейцарский зенненхунд' },
    { label: 'Бордер-колли', value: 'Бордер-колли' },
    { label: 'Бордер-терьер', value: 'Бордер-терьер' },
    { label: 'Бордоский дог', value: 'Бордоский дог' },
    { label: 'Бородатый колли', value: 'Бородатый колли' },
    { label: 'Босерон', value: 'Босерон' },
    { label: 'Боснийская жесткошёрстная гончая (барак)', value: 'Боснийская жесткошёрстная гончая (барак)' },
    { label: 'Бостон-терьер', value: 'Бостон-терьер' },
    { label: 'Бразильский терьер', value: 'Бразильский терьер' },
    { label: 'Бразильский фила', value: 'Бразильский фила' },
    { label: 'Бретонский эпаньол', value: 'Бретонский эпаньол' },
    { label: 'Бриар', value: 'Бриар' },
    { label: 'Брохольмер', value: 'Брохольмер' },
    { label: 'Брюссельский гриффон', value: 'Брюссельский гриффон' },
    { label: 'Бульмастиф', value: 'Бульмастиф' },
    { label: 'Бультерьер', value: 'Бультерьер' },
    { label: 'Бурбуль', value: 'Бурбуль' },
    { label: 'Бурят-монгольский волкодав', value: 'Бурят-монгольский волкодав' },
    { label: 'Веймаранер', value: 'Веймаранер' },
    { label: 'Вельш-корги-кардиган', value: 'Вельш-корги-кардиган' },
    { label: 'Вельш-корги-пемброк', value: 'Вельш-корги-пемброк' },
    { label: 'Вельш-терьер', value: 'Вельш-терьер' },
    { label: 'Вельштерьер', value: 'Вельштерьер' },
    { label: 'Венгерская борзая', value: 'Венгерская борзая' },
    { label: 'Венгерская жесткошерстная выжла', value: 'Венгерская жесткошерстная выжла' },
    { label: 'Венгерская короткошёрстная выжла', value: 'Венгерская короткошёрстная выжла' },
    { label: 'Вест-хайленд-уайт-терьер', value: 'Вест-хайленд-уайт-терьер' },
    { label: 'Вестфальский таксообразный бракк', value: 'Вестфальский таксообразный бракк' },
    { label: 'Вестхайленд-уайт-терьер', value: 'Вестхайленд-уайт-терьер' },
    { label: 'Виппет', value: 'Виппет' },
    { label: 'Волжская овчарка', value: 'Волжская овчарка' },
    { label: 'Волчья собака Саарлоса', value: 'Волчья собака Саарлоса' },
    { label: 'Вольпино итальяно', value: 'Вольпино итальяно' },
    { label: 'Восточноевропейская овчарка', value: 'Восточноевропейская овчарка' },
    { label: 'Восточносибирская лайка', value: 'Восточносибирская лайка' },
    { label: 'Гаванский бишон', value: 'Гаванский бишон' },
    { label: 'Гампр (армянский волкодав)', value: 'Гампр (армянский волкодав)' },
    { label: 'Гасконская сэнтожская гончая', value: 'Гасконская сэнтожская гончая' },
    { label: 'Глен оф Имаал терьер', value: 'Глен оф Имаал терьер' },
    { label: 'Голландская овчарка (Хердер)', value: 'Голландская овчарка (Хердер)' },
    { label: 'Голландский смоусхонд', value: 'Голландский смоусхонд' },
    { label: 'Голубой гасконский бассет', value: 'Голубой гасконский бассет' },
    { label: 'Голубой гасконский гриффон', value: 'Голубой гасконский гриффон' },
    { label: 'Гончая Гамильтона', value: 'Гончая Гамильтона' },
    { label: 'Гончая Шиллера', value: 'Гончая Шиллера' },
    { label: 'Грейт-дейн (Датский дог)', value: 'Грейт-дейн (Датский дог)' },
    { label: 'Грейхаунд', value: 'Грейхаунд' },
    { label: 'Гренландская собака', value: 'Гренландская собака' },
    { label: 'Гриффон', value: 'Гриффон' },
    { label: 'Грюнендаль', value: 'Грюнендаль' },
    { label: 'Далматин', value: 'Далматин' },
    { label: 'Денди-динмонт-терьер', value: 'Денди-динмонт-терьер' },
    { label: 'Джек-рассел-терьер', value: 'Джек-рассел-терьер' },
    { label: 'Доберман', value: 'Доберман' },
    { label: 'Древер', value: 'Древер' },
    { label: 'Древесная енотовая гончая', value: 'Древесная енотовая гончая' },
    { label: 'Евразиер', value: 'Евразиер' },
    { label: 'Западносибирская лайка', value: 'Западносибирская лайка' },
    { label: 'Золотистый ретривер', value: 'Золотистый ретривер' },
    { label: 'Ирландский волкодав', value: 'Ирландский волкодав' },
    { label: 'Ирландский красно-белый сеттер', value: 'Ирландский красно-белый сеттер' },
    { label: 'Ирландский красный сеттер', value: 'Ирландский красный сеттер' },
    { label: 'Ирландский мягкошерстный пшеничный терьер', value: 'Ирландский мягкошерстный пшеничный терьер' },
    { label: 'Ирландский терьер', value: 'Ирландский терьер' },
    { label: 'Исландская собака', value: 'Исландская собака' },
    { label: 'Испанская водяная собака', value: 'Испанская водяная собака' },
    { label: 'Испанская гончая', value: 'Испанская гончая' },
    { label: 'Испанский грейхаунд', value: 'Испанский грейхаунд' },
    { label: 'Испанский мастиф', value: 'Испанский мастиф' },
    { label: 'Истрийская жесткошёрстная гончая', value: 'Истрийская жесткошёрстная гончая' },
    { label: 'Истрийская короткошёрстная гончая', value: 'Истрийская короткошёрстная гончая' },
    { label: 'Итальянский бракк', value: 'Итальянский бракк' },
    { label: 'Йоркширский терьер', value: 'Йоркширский терьер' },
    { label: 'Ка-де-бо', value: 'Ка-де-бо' },
    { label: 'Кавалер-кинг-чарльз-спаниель', value: 'Кавалер-кинг-чарльз-спаниель' },
    { label: 'Кавказская овчарка', value: 'Кавказская овчарка' },
    { label: 'Каи', value: 'Каи' },
    { label: 'Канарский дог', value: 'Канарский дог' },
    { label: 'Кангал', value: 'Кангал' },
    { label: 'Кане-корсо', value: 'Кане-корсо' },
    { label: 'Карело-финская лайка', value: 'Карело-финская лайка' },
    { label: 'Карельская медвежья собака', value: 'Карельская медвежья собака' },
    { label: 'Карликовая такса', value: 'Карликовая такса' },
    { label: 'Карликовый пинчер', value: 'Карликовый пинчер' },
    { label: 'Карликовый пудель', value: 'Карликовый пудель' },
    { label: 'Каталонская овчарка', value: 'Каталонская овчарка' },
    { label: 'Кеесхонд', value: 'Кеесхонд' },
    { label: 'Керн-терьер', value: 'Керн-терьер' },
    { label: 'Керри-блю-терьер', value: 'Керри-блю-терьер' },
    { label: 'Кинг-чарльз-спаниель', value: 'Кинг-чарльз-спаниель' },
    { label: 'Кисю', value: 'Кисю' },
    { label: 'Китайская хохлатая собака', value: 'Китайская хохлатая собака' },
    { label: 'Кламбер-спаниель', value: 'Кламбер-спаниель' },
    { label: 'Кокапу', value: 'Кокапу' },
    { label: 'Колли длинношерстный', value: 'Колли длинношерстный' },
    { label: 'Колли короткошерстный', value: 'Колли короткошерстный' },
    { label: 'Комондор', value: 'Комондор' },
    { label: 'Корейский чиндо', value: 'Корейский чиндо' },
    { label: 'Котон де Тулеар', value: 'Котон де Тулеар' },
    { label: 'Котон-де-тулеар (мадагаскарская болонка)', value: 'Котон-де-тулеар (мадагаскарская болонка)' },
    { label: 'Крашская овчарка', value: 'Крашская овчарка' },
    { label: 'Ксолоитцкуинтли', value: 'Ксолоитцкуинтли' },
    { label: 'Кувас', value: 'Кувас' },
    { label: 'Курцхаар', value: 'Курцхаар' },
    { label: 'Курчавошёрстный ретривер', value: 'Курчавошёрстный ретривер' },
    { label: 'Лабрадор', value: 'Лабрадор' },
    { label: 'Лабрадор-ретривер', value: 'Лабрадор-ретривер' },
    { label: 'Лабрадудль', value: 'Лабрадудль' },
    { label: 'Лаготто-романьоло', value: 'Лаготто-романьоло' },
    { label: 'Ландзир', value: 'Ландзир' },
    { label: 'Ландсир', value: 'Ландсир' },
    { label: 'Ланкаширский хилер', value: 'Ланкаширский хилер' },
    { label: 'Левретка', value: 'Левретка' },
    { label: 'Лейкленд-терьер', value: 'Лейкленд-терьер' },
    { label: 'Леонбергер', value: 'Леонбергер' },
    { label: 'Лопарская оленегонная собака', value: 'Лопарская оленегонная собака' },
    { label: 'Лхаса апсо', value: 'Лхаса апсо' },
    { label: 'Майоркская овчарка', value: 'Майоркская овчарка' },
    { label: 'Малая голубая гасконская гончая', value: 'Малая голубая гасконская гончая' },
    { label: 'Малая львиная собака', value: 'Малая львиная собака' },
    { label: 'Малая швейцарская гончая', value: 'Малая швейцарская гончая' },
    { label: 'Малый вандейский бассет-гриффон', value: 'Малый вандейский бассет-гриффон' },
    { label: 'Мальтезе', value: 'Мальтезе' },
    { label: 'Мальтийская болонка', value: 'Мальтийская болонка' },
    { label: 'Мальтипу', value: 'Мальтипу' },
    { label: 'Мареммо-абруцкая овчарка', value: 'Мареммо-абруцкая овчарка' },
    { label: 'Миниатюрный бультерьер', value: 'Миниатюрный бультерьер' },
    { label: 'Миттельшнауцер', value: 'Миттельшнауцер' },
    { label: 'Мопс', value: 'Мопс' },
    { label: 'Московская сторожевая', value: 'Московская сторожевая' },
    { label: 'Муди', value: 'Муди' },
    { label: 'Неаполитанский мастиф', value: 'Неаполитанский мастиф' },
    { label: 'Немецкая овчарка', value: 'Немецкая овчарка' },
    { label: 'Немецкий боксер', value: 'Немецкий боксер' },
    { label: 'Немецкий бракк', value: 'Немецкий бракк' },
    { label: 'Немецкий вахтельхунд (спаниель)', value: 'Немецкий вахтельхунд (спаниель)' },
    { label: 'Немецкий дог', value: 'Немецкий дог' },
    { label: 'Немецкий дратхаар', value: 'Немецкий дратхаар' },
    { label: 'Немецкий пинчер', value: 'Немецкий пинчер' },
    { label: 'Немецкий шпиц', value: 'Немецкий шпиц' },
    { label: 'Немецкий шпиц (померанский)', value: 'Немецкий шпиц (померанский)' },
    { label: 'Немецкий штихельхаар', value: 'Немецкий штихельхаар' },
    { label: 'Немецкий ягдтерьер', value: 'Немецкий ягдтерьер' },
    { label: 'Нивернейский гриффон', value: 'Нивернейский гриффон' },
    { label: 'Новошотландский ретривер', value: 'Новошотландский ретривер' },
    { label: 'Норботтен шпиц', value: 'Норботтен шпиц' },
    { label: 'Норвежский бухунд', value: 'Норвежский бухунд' },
    { label: 'Норвежский лундехунд', value: 'Норвежский лундехунд' },
    { label: 'Норвежский серый элкхунд', value: 'Норвежский серый элкхунд' },
    { label: 'Норвежский чёрный элкхунд', value: 'Норвежский чёрный элкхунд' },
    { label: 'Норвич-терьер', value: 'Норвич-терьер' },
    { label: 'Норфолк-терьер', value: 'Норфолк-терьер' },
    { label: 'Ньюфаундленд', value: 'Ньюфаундленд' },
    { label: 'Оттерхаунд', value: 'Оттерхаунд' },
    { label: 'Папильон (папийон)', value: 'Папильон (папийон)' },
    { label: 'Парсон-рассел-терьер', value: 'Парсон-рассел-терьер' },
    { label: 'Пекинес', value: 'Пекинес' },
    { label: 'Перуанская голая собака', value: 'Перуанская голая собака' },
    { label: 'Пикардийская овчарка', value: 'Пикардийская овчарка' },
    { label: 'Пиренейская горная собака', value: 'Пиренейская горная собака' },
    { label: 'Пиренейская овчарка', value: 'Пиренейская овчарка' },
    { label: 'Пиренейский мастиф', value: 'Пиренейский мастиф' },
    { label: 'Поденго', value: 'Поденго' },
    { label: 'Поденко ибиценко', value: 'Поденко ибиценко' },
    { label: 'Подлещик', value: 'Подлещик' },
    { label: 'Польская гончая', value: 'Польская гончая' },
    { label: 'Польская низинная овчарка', value: 'Польская низинная овчарка' },
    { label: 'Польская подгалянская овчарка', value: 'Польская подгалянская овчарка' },
    { label: 'Польский огар', value: 'Польский огар' },
    { label: 'Польский харт', value: 'Польский харт' },
    { label: 'Померанский шпиц', value: 'Померанский шпиц' },
    { label: 'Помски', value: 'Помски' },
    { label: 'Португальская водяная собака', value: 'Португальская водяная собака' },
    { label: 'Португальская овчарка', value: 'Португальская овчарка' },
    { label: 'Португальский поденгу', value: 'Португальский поденгу' },
    { label: 'Посавская гончая', value: 'Посавская гончая' },
    { label: 'Пражский крысарик', value: 'Пражский крысарик' },
    { label: 'Прямошерстный ретривер', value: 'Прямошерстный ретривер' },
    { label: 'Пти (малый) брабансон', value: 'Пти (малый) брабансон' },
    { label: 'Пудель', value: 'Пудель' },
    { label: 'Пули', value: 'Пули' },
    { label: 'Пуми', value: 'Пуми' },
    { label: 'Рафейро до Алентехо', value: 'Рафейро до Алентехо' },
    { label: 'Ризеншнауцер', value: 'Ризеншнауцер' },
    { label: 'Родезийский риджбек', value: 'Родезийский риджбек' },
    { label: 'Ротвейлер', value: 'Ротвейлер' },
    { label: 'Румынская карпатская овчарка', value: 'Румынская карпатская овчарка' },
    { label: 'Румынская миоритская овчарка', value: 'Румынская миоритская овчарка' },
    { label: 'Русская гончая', value: 'Русская гончая' },
    { label: 'Русская псовая борзая', value: 'Русская псовая борзая' },
    { label: 'Русская цветная болонка', value: 'Русская цветная болонка' },
    { label: 'Русский охотничий спаниель', value: 'Русский охотничий спаниель' },
    { label: 'Русский той', value: 'Русский той' },
    { label: 'Русский черный терьер', value: 'Русский черный терьер' },
    { label: 'Русско-европейская лайка', value: 'Русско-европейская лайка' },
    { label: 'Рыжий бретонский бассет', value: 'Рыжий бретонский бассет' },
    { label: 'Салюки', value: 'Салюки' },
    { label: 'Самоед', value: 'Самоед' },
    { label: 'Сенбернар', value: 'Сенбернар' },
    { label: 'Сербская гончая', value: 'Сербская гончая' },
    { label: 'Сербская трёхцветная гончая', value: 'Сербская трёхцветная гончая' },
    { label: 'Сеттер-гордон', value: 'Сеттер-гордон' },
    { label: 'Сиба', value: 'Сиба' },
    { label: 'Сибирский хаски', value: 'Сибирский хаски' },
    { label: 'Сикоку', value: 'Сикоку' },
    { label: 'Силихем-терьер', value: 'Силихем-терьер' },
    { label: 'Скайтерьер', value: 'Скайтерьер' },
    { label: 'Скотчтерьер (шотландский терьер)', value: 'Скотчтерьер (шотландский терьер)' },
    { label: 'Словацкий чувач', value: 'Словацкий чувач' },
    { label: 'Смоландская гончая', value: 'Смоландская гончая' },
    { label: 'Среднеазиатская овчарка (алабай)', value: 'Среднеазиатская овчарка (алабай)' },
    { label: 'Староанглийская овчарка (бобтейл)', value: 'Староанглийская овчарка (бобтейл)' },
    { label: 'Стаффордширский бультерьер', value: 'Стаффордширский бультерьер' },
    { label: 'Суссекс-спаниель', value: 'Суссекс-спаниель' },
    { label: 'Тайваньская собака', value: 'Тайваньская собака' },
    { label: 'Тайский риджбек', value: 'Тайский риджбек' },
    { label: 'Такса', value: 'Такса' },
    { label: 'Тибетский мастиф', value: 'Тибетский мастиф' },
    { label: 'Тибетский спаниель', value: 'Тибетский спаниель' },
    { label: 'Тибетский терьер', value: 'Тибетский терьер' },
    { label: 'Той-фокстерьер', value: 'Той-фокстерьер' },
    { label: 'Торньяк', value: 'Торньяк' },
    { label: 'Тоса', value: 'Тоса' },
    { label: 'Трансильванская гончая', value: 'Трансильванская гончая' },
    { label: 'Турецкий акбаш', value: 'Турецкий акбаш' },
    { label: 'Уиппет', value: 'Уиппет' },
    { label: 'Уругвайский симаррон', value: 'Уругвайский симаррон' },
    { label: 'Фараонова собака', value: 'Фараонова собака' },
    { label: 'Фила Сан-Мигель', value: 'Фила Сан-Мигель' },
    { label: 'Филд-спаниель', value: 'Филд-спаниель' },
    { label: 'Финская гончая', value: 'Финская гончая' },
    { label: 'Финский лаппхунд', value: 'Финский лаппхунд' },
    { label: 'Финский шпиц', value: 'Финский шпиц' },
    { label: 'Фландрский бувье', value: 'Фландрский бувье' },
    { label: 'Фокстерьер гладкошерстный', value: 'Фокстерьер гладкошерстный' },
    { label: 'Фокстерьер жесткошерстный', value: 'Фокстерьер жесткошерстный' },
    { label: 'Французская бело-рыжая гончая', value: 'Французская бело-рыжая гончая' },
    { label: 'Французская бело-чёрная гончая', value: 'Французская бело-чёрная гончая' },
    { label: 'Французская трехцветная гончая', value: 'Французская трехцветная гончая' },
    { label: 'Французский бульдог', value: 'Французский бульдог' },
    { label: 'Хальденская гончая', value: 'Хальденская гончая' },
    { label: 'Ханаанская собака', value: 'Ханаанская собака' },
    { label: 'Харьер', value: 'Харьер' },
    { label: 'Ховаварт', value: 'Ховаварт' },
    { label: 'Хоккайдо', value: 'Хоккайдо' },
    { label: 'Хорватская овчарка', value: 'Хорватская овчарка' },
    { label: 'Хюгенхунд', value: 'Хюгенхунд' },
    { label: 'Цвергшнауцер', value: 'Цвергшнауцер' },
    { label: 'Чау-чау', value: 'Чау-чау' },
    { label: 'Чёрно-подпалый кунхаунд', value: 'Чёрно-подпалый кунхаунд' },
    { label: 'Черногорская горная гончая', value: 'Черногорская горная гончая' },
    { label: 'Чесапик бэй ретривер', value: 'Чесапик бэй ретривер' },
    { label: 'Чехословацкая волчья собака', value: 'Чехословацкая волчья собака' },
    { label: 'Чешский терьер', value: 'Чешский терьер' },
    { label: 'Чирнеко дель Этна', value: 'Чирнеко дель Этна' },
    { label: 'Чихуахуа', value: 'Чихуахуа' },
    { label: 'Шалайка', value: 'Шалайка' },
    { label: 'Шапендуа', value: 'Шапендуа' },
    { label: 'Шарпей', value: 'Шарпей' },
    { label: 'Шарпланинац', value: 'Шарпланинац' },
    { label: 'Шведский вальхунд', value: 'Шведский вальхунд' },
    { label: 'Шведский лаппхунд', value: 'Шведский лаппхунд' },
    { label: 'Швейцарская гончая', value: 'Швейцарская гончая' },
    { label: 'Шелти', value: 'Шелти' },
    { label: 'Ши-тцу', value: 'Ши-тцу' },
    { label: 'Шипперке', value: 'Шипперке' },
    { label: 'Шнауцер', value: 'Шнауцер' },
    { label: 'Шотландский сеттер', value: 'Шотландский сеттер' },
    { label: 'Шотландский терьер', value: 'Шотландский терьер' },
    { label: 'Энтлебухер зенненхунд', value: 'Энтлебухер зенненхунд' },
    { label: 'Эрдельтерьер', value: 'Эрдельтерьер' },
    { label: 'Эстонская гончая', value: 'Эстонская гончая' },
    { label: 'Эштрельская овчарка', value: 'Эштрельская овчарка' },
    { label: 'Южнорусская овчарка', value: 'Южнорусская овчарка' },
    { label: 'Ямтхунд', value: 'Ямтхунд' },
    { label: 'Японский терьер', value: 'Японский терьер' },
    { label: 'Японский хин', value: 'Японский хин' },
    { label: 'Японский шпиц', value: 'Японский шпиц' },
];

const catBreeds = [
    { label: 'Без породы (домашняя кошка)', value: 'Без породы (домашняя кошка)' },
    { label: 'Абиссинская кошка', value: 'Абиссинская кошка' },
    { label: 'Австралийский мист', value: 'Австралийский мист' },
    { label: 'Азиатская табби', value: 'Азиатская табби' },
    { label: 'Американская жесткошерстная', value: 'Американская жесткошерстная' },
    { label: 'Американская короткошерстная', value: 'Американская короткошерстная' },
    { label: 'Американский бобтейл', value: 'Американский бобтейл' },
    { label: 'Американский керл', value: 'Американский керл' },
    { label: 'Анатолийская', value: 'Анатолийская' },
    { label: 'Аравийский мау', value: 'Аравийский мау' },
    { label: 'Ашера', value: 'Ашера' },
    { label: 'Балинезийская (балийская)', value: 'Балинезийская (балийская)' },
    { label: 'Бамбино', value: 'Бамбино' },
    { label: 'Бенгальская', value: 'Бенгальская' },
    { label: 'Бирманская (священная бирма)', value: 'Бирманская (священная бирма)' },
    { label: 'Бомбейская', value: 'Бомбейская' },
    { label: 'Бразильская', value: 'Бразильская' },
    { label: 'Британская кошка', value: 'Британская кошка' },
    { label: 'Бурманская', value: 'Бурманская' },
    { label: 'Бурмилла', value: 'Бурмилла' },
    { label: 'Гавана Браун', value: 'Гавана Браун' },
    { label: 'Гигантская афродита', value: 'Гигантская афродита' },
    { label: 'Гималайская', value: 'Гималайская' },
    { label: 'Девон-рекс', value: 'Девон-рекс' },
    { label: 'Донской сфинкс', value: 'Донской сфинкс' },
    { label: 'Дракон Ли', value: 'Дракон Ли' },
    { label: 'Египетский мау', value: 'Египетский мау' },
    { label: 'Калифорнийская сияющая', value: 'Калифорнийская сияющая' },
    { label: 'Канаани', value: 'Канаани' },
    { label: 'Канадский сфинкс', value: 'Канадский сфинкс' },
    { label: 'Као мани', value: 'Као мани' },
    { label: 'Каракал', value: 'Каракал' },
    { label: 'Каракет', value: 'Каракет' },
    { label: 'Карельский бобтейл', value: 'Карельский бобтейл' },
    { label: 'Кельтская (Европейская короткошерстная)', value: 'Кельтская (Европейская короткошерстная)' },
    { label: 'Кимрик', value: 'Кимрик' },
    { label: 'Кинкалоу', value: 'Кинкалоу' },
    { label: 'Корат', value: 'Корат' },
    { label: 'Корниш-рекс', value: 'Корниш-рекс' },
    { label: 'Курильский бобтейл', value: 'Курильский бобтейл' },
    { label: 'Лаперм', value: 'Лаперм' },
    { label: 'Ликой', value: 'Ликой' },
    { label: 'Манул', value: 'Манул' },
    { label: 'Манчкин', value: 'Манчкин' },
    { label: 'Мейн-кун', value: 'Мейн-кун' },
    { label: 'Меконгский бобтейл', value: 'Меконгский бобтейл' },
    { label: 'Минскин', value: 'Минскин' },
    { label: 'Мэнкс (Мэнская кошка)', value: 'Мэнкс (Мэнская кошка)' },
    { label: 'Наполеон', value: 'Наполеон' },
    { label: 'Невская маскарадная', value: 'Невская маскарадная' },
    { label: 'Немецкий рекс', value: 'Немецкий рекс' },
    { label: 'Нибелунг', value: 'Нибелунг' },
    { label: 'Норвежская лесная', value: 'Норвежская лесная' },
    { label: 'Орегон-рекс', value: 'Орегон-рекс' },
    { label: 'Ориентальная', value: 'Ориентальная' },
    { label: 'Охос азулес', value: 'Охос азулес' },
    { label: 'Оцикет', value: 'Оцикет' },
    { label: 'Персидская', value: 'Персидская' },
    { label: 'Петербургский сфинкс (Петерболд)', value: 'Петербургский сфинкс (Петерболд)' },
    { label: 'Пикси-боб', value: 'Пикси-боб' },
    { label: 'Рагамаффин', value: 'Рагамаффин' },
    { label: 'Русская голубая', value: 'Русская голубая' },
    { label: 'Рэгдолл', value: 'Рэгдолл' },
    { label: 'Саванна', value: 'Саванна' },
    { label: 'Селкирк-рекс', value: 'Селкирк-рекс' },
    { label: 'Сервал', value: 'Сервал' },
    { label: 'Серенгети', value: 'Серенгети' },
    { label: 'Сиамская', value: 'Сиамская' },
    { label: 'Сибирская (невская маскарадная)', value: 'Сибирская (невская маскарадная)' },
    { label: 'Сингапурская', value: 'Сингапурская' },
    { label: 'Скукум', value: 'Скукум' },
    { label: 'Сноу-шу', value: 'Сноу-шу' },
    { label: 'Сококе', value: 'Сококе' },
    { label: 'Сомалийская', value: 'Сомалийская' },
    { label: 'Сфинкс браш', value: 'Сфинкс браш' },
    { label: 'Тайская кошка', value: 'Тайская кошка' },
    { label: 'Той-боб (карликовый бобтейл)', value: 'Той-боб (карликовый бобтейл)' },
    { label: 'Тойгер', value: 'Тойгер' },
    { label: 'Тонкинская', value: 'Тонкинская' },
    { label: 'Турецкая ангора', value: 'Турецкая ангора' },
    { label: 'Турецкий ван', value: 'Турецкий ван' },
    { label: 'Украинский левкой', value: 'Украинский левкой' },
    { label: 'Уральский рекс', value: 'Уральский рекс' },
    { label: 'Хайленд страйт', value: 'Хайленд страйт' },
    { label: 'Цейлонская', value: 'Цейлонская' },
    { label: 'Чаузи', value: 'Чаузи' },
    { label: 'Шантильи Тиффани', value: 'Шантильи Тиффани' },
    { label: 'Шартрез (Картезианская)', value: 'Шартрез (Картезианская)' },
    { label: 'Шиншилла', value: 'Шиншилла' },
    { label: 'Шотладская вислоухая (скоттиш-фолд)', value: 'Шотладская вислоухая (скоттиш-фолд)' },
    { label: 'Шотландская прямоухая', value: 'Шотландская прямоухая' },
    { label: 'Эгейская кошка', value: 'Эгейская кошка' },
    { label: 'Экзотическая', value: 'Экзотическая' },
    { label: 'Эльф', value: 'Эльф' },
    { label: 'Яванская', value: 'Яванская' },
    { label: 'Японский бобтейл', value: 'Японский бобтейл' },
];

export const breeds = {
    [Animals.cat]: catBreeds,
    [Animals.dog]: dogBreeds,
    [Animals.other]: [
        { label: 'Особенная ❤️', value: 'Особенная' },
        { label: 'Счастье не в породе', value: 'Счастье не в породе' },
    ],
};
